import React, { createContext, useContext, useState, useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { PersonContext } from '../../PersonContext'
// needs to be imported like this because default values cannot be mocked
import { deleteOsrs } from '../../../../services/ordinanceService'
import useNotifications from '../../../../hooks/useNotifications'

export const DeleteOsrContext = createContext()

export function DeleteOsrContextProvider({ children }) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const { fetchCurrentPerson } = useContext(PersonContext)
  const [owsIdsToDelete, setOwsIdsToDelete] = useState([])

  const handleDeleteOsrChange = useCallback(
    (event, owsId) => {
      if (event.target.checked && owsIdsToDelete.indexOf(owsId) === -1) {
        setOwsIdsToDelete((prevState) => [...prevState, owsId])
      } else if (!event.target.checked && owsIdsToDelete.indexOf(owsId) !== -1) {
        setOwsIdsToDelete((prevState) => prevState.filter((id) => id !== owsId))
      }
    },
    [owsIdsToDelete]
  )

  const handleDeleteOsrs = useCallback(() => {
    deleteOsrs(owsIdsToDelete)
      .then(() => {
        fetchCurrentPerson()
      })
      .catch((err) => {
        error(
          t('person.ordinances.errors.deletingOsr', {
            defaultValue: `Error deleting OSR: ${err.message || ''}`,
            message: err.message || '',
          }),
          err
        )
      })
  }, [owsIdsToDelete, fetchCurrentPerson, error, t])

  const value = useMemo(
    () => ({
      owsIdsToDelete,
      handleDeleteOsrChange,
      handleDeleteOsrs,
    }),
    [owsIdsToDelete, handleDeleteOsrChange, handleDeleteOsrs]
  )

  return <DeleteOsrContext.Provider value={value}>{children}</DeleteOsrContext.Provider>
}
